import { APIResponse, APIResponseDtoImpl } from '../apiresponse';

export interface ForgotPasswordResponse extends APIResponse 
{
}

export class ForgotPasswordResponseDtoImpl extends APIResponseDtoImpl implements ForgotPasswordResponse
{
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/forgotpassword/forgotpasswordresponse.tsx